/**
 * Harbinger rule overrides.
 *
 * Card text (verbatim from sorcery-cards.json):
 *   "Tap → Play or draw a site.
 *    On setup, determine three random squares. Once on your turn,
 *    you can cast a minion to one of them and for (1) less."
 *
 * The Tap line is the standard avatar ability (no override needed).
 * The setup line is wired entirely through GameBoard's
 * `_maybeFireHarbingerSetup` hook + a MODIFY_CAST_COST ledger entry
 * carrying the picked cells in args.filter.cells; the discount is
 * applied at the destination cell during cast. This rule file exists
 * so the registry knows Harbinger is a recognised avatar (consistent
 * with the other avatars that the resolver enumerates).
 */
export const HARBINGER_RULES = {};
